import { type ReactNode } from 'react';
import { cn } from '@/utils/cn';

const paddings = {
  sm: 'p-4',
  md: 'p-5',
  lg: 'p-6',
} as const;

interface CardProps {
  children: ReactNode;
  title?: string;
  action?: ReactNode;
  padding?: keyof typeof paddings;
  className?: string;
}

export function Card({ children, title, action, padding = 'md', className }: CardProps) {
  return (
    <div className={cn('rounded-xl border border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-800', paddings[padding], className)}>
      {(title || action) && (
        <div className="mb-4 flex items-center justify-between">
          {title && <h3 className="text-base font-semibold text-gray-900 dark:text-gray-100">{title}</h3>}
          {action}
        </div>
      )}
      {children}
    </div>
  );
}
